module.exports = __webpack_public_path__ + "img/icon_map_5_6.fb41488c.png";